import {
    GET_UNID_URL,
    GET_UNID_URL_SUCCESS,
    GET_UNID_URL_FAILURE,
    DELETE_UNID_URL
} from '../actions';

const initialState = {
    loading: false,
    unidUrl: '',
};

const UnidUrlReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_UNID_URL:
            return {
                ...state,
                loading: true,
            };
        case GET_UNID_URL_SUCCESS:
            return {
                ...state,
                loading: false,
                unidUrl: action.payload,
            };
        case GET_UNID_URL_FAILURE:
            return {
                ...state,
                loading: false,
            };
        case DELETE_UNID_URL:
            return {
                ...state,
                unidUrl: '',
            };
        default:
            return {
                ...state,
            };
    }
};

export default UnidUrlReducer;
